var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorCircleOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_406)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.23C12.127 16.23 12.23 16.127 12.23 16C12.23 15.873 12.127 15.77 12 15.77C11.873 15.77 11.77 15.873 11.77 16C11.77 16.127 11.873 16.23 12 16.23ZM11.27 16C11.27 15.5969 11.5969 15.27 12 15.27C12.4032 15.27 12.73 15.5969 12.73 16C12.73 16.4032 12.4032 16.73 12 16.73C11.5969 16.73 11.27 16.4032 11.27 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.02002C12.2651 7.02002 12.48 7.23492 12.48 7.50002V13.5625C12.48 13.8276 12.2651 14.0425 12 14.0425C11.7349 14.0425 11.52 13.8276 11.52 13.5625V7.50002C11.52 7.23492 11.7349 7.02002 12 7.02002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.98002C7.01841 2.98002 2.98002 7.01841 2.98002 12C2.98002 16.9816 7.01841 21.02 12 21.02C16.9816 21.02 21.02 16.9816 21.02 12C21.02 7.01841 16.9816 2.98002 12 2.98002ZM2.02002 12C2.02002 6.48822 6.48822 2.02002 12 2.02002C17.5118 2.02002 21.98 6.48822 21.98 12C21.98 17.5118 17.5118 21.98 12 21.98C6.48822 21.98 2.02002 17.5118 2.02002 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.355C12.1961 16.355 12.355 16.1961 12.355 16C12.355 15.804 12.1961 15.645 12 15.645C11.804 15.645 11.645 15.804 11.645 16C11.645 16.1961 11.804 16.355 12 16.355ZM11.395 16C11.395 15.6659 11.6659 15.395 12 15.395C12.3342 15.395 12.605 15.6659 12.605 16C12.605 16.3342 12.3342 16.605 12 16.605C11.6659 16.605 11.395 16.3342 11.395 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 16.7551C12.4171 16.7551 12.7551 16.4171 12.7551 16.0001C12.7551 15.5831 12.4171 15.2451 12.0001 15.2451C11.5831 15.2451 11.2451 15.5831 11.2451 16.0001C11.2451 16.4171 11.5831 16.7551 12.0001 16.7551Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircleOutlineIcon);
export default __webpack_public_path__ + "static/media/error-circle-outline-icon.2d39b223eb1ea99eb32ee3892c08c805.svg";
export { ForwardRef as ReactComponent };